// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7cztO","index":"styles_index__1_Xu_"};